class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    if (!this.dataset.url) {
      console.warn('[MiniCart] data-url nerastas ant <mini-cart> elemento.');
      return;
    }

    if (!this.drawer) {
      console.warn('[MiniCart] <cart-drawer> elementas nerastas.');
    }

    this.observer = new IntersectionObserver(this.handleIntersection);
    this.observer.observe(this);
  }

  handleIntersection(entries, observer) {
    const entry = entries[0];
    if (!entry || !entry.isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const miniCart = document.getElementById('mini-cart');

        if (!miniCart) {
          console.warn('[MiniCart] #mini-cart elementas nerastas DOM’e.');
          return;
        }

        miniCart.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');

        // pranešam, kad mini-cart turinys atnaujintas
        document.dispatchEvent(
          new CustomEvent('mini-cart:updated', { bubbles: true })
        );

        document.dispatchEvent(
          new CustomEvent('cartdrawer:opened', { bubbles: true })
        );
      })
      .catch((e) => {
        console.error('[MiniCart] Klaida fetch’inant mini-cart sekciją:', e);
      });
  }

  open() {
    if (!this.drawer) return;

    const detailsElement = this.drawer.querySelector('details');
    if (!detailsElement) {
      console.warn(
        '[MiniCart] cart-drawer viduje nerastas <details> elementas.'
      );
      return;
    }

    // Užtikriname, kad krepšelis visada atsidarytų nuo pat viršaus.
    const scrollable = this.drawer.querySelector('.mini-cart__main');
    if (scrollable) {
      scrollable.scrollTop = 0;
    }

    if (detailsElement.hasAttribute('open')) {
      return;
    }

    if (typeof this.drawer.openMenuDrawer === 'function') {
      this.drawer.openMenuDrawer();
    } else {
      detailsElement.setAttribute('open', 'open');
    }
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    // Sustabdome "lazy-load" stebėjimą — turinys jau atnaujinamas čia,
    // tiesiogiai iš add-to-cart atsakymo, tad nebereikia jo antrą kartą
    // pakartotinai užkrauti per IntersectionObserver (tai sukeldavo
    // scroll pozicijos "šuolį" pridedant pačią pirmą prekę).
    if (this.observer) {
      this.observer.unobserve(this);
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;

      const sectionHTML = parsedState.sections[section.id];
      if (!sectionHTML) return;

      container.innerHTML = this.getSectionInnerHTML(
        sectionHTML,
        section.selector
      );
    });

    this.open();

    // kai mini-cart atnaujinamas per AJAX (add to cart), irgi pranešam
    document.dispatchEvent(
      new CustomEvent('mini-cart:updated', { bubbles: true })
    );
  }

  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector(selector);

    if (!section) {
      console.warn(
        `[MiniCart] Selektorius "${selector}" nerastas gautoje HTML sekcijoje.`
      );
      return '';
    }

    return section.innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

// --------------------------------------
// Variant picker krepšelyje (drawer + cart puslapis)
// + rekomenduojamų produktų burbuliukai mini-cart'e
// --------------------------------------
(function () {
  const SECTIONS_TO_RENDER = [
    'mini-cart',
    'cart-icon-bubble',
    'mobile-cart-icon-bubble',
  ];

  function closeAllVariantPickers() {
    document
      .querySelectorAll('.cart-variant-picker--open')
      .forEach(function (picker) {
        picker.classList.remove('cart-variant-picker--open');
        const trigger = picker.querySelector('.cart-variant-picker__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
  }

  // -------------------------------
  // Burbuliukai – helper funkcijos
  // -------------------------------
  function getNavFromDot(dot) {
    const block = dot.closest('.cart-recommendations');
    if (!block) return null;
    return block.querySelector('.mini-cart__navigation');
  }

  function getDotsForNav(nav) {
    if (!nav) return [];
    const block = nav.closest('.cart-recommendations');
    if (!block) return [];
    const wrapper = block.querySelector('.mini-cart__dots');
    if (!wrapper) return [];
    return wrapper.querySelectorAll('.mini-cart__dot');
  }

  function getItemsForNav(nav) {
    if (!nav) return [];
    return nav.querySelectorAll('li');
  }

  // Atnaujina aktyvų burbuliuką pagal tai, kuris produktas arčiausiai centro
  function updateDotsForNav(nav) {
    if (!nav) return;

    const dots = getDotsForNav(nav);
    const items = getItemsForNav(nav);

    if (!dots.length || !items.length) return;

    const containerRect = nav.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;

    let closestIndex = 0;
    let minDiff = Infinity;

    items.forEach(function (item, index) {
      const rect = item.getBoundingClientRect();
      const itemCenter = rect.left + rect.width / 2;
      const diff = Math.abs(itemCenter - containerCenter);

      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = index;
      }
    });

    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === closestIndex);
    });
  }

  // Inicijuojam burbuliukus pagal esamą poziciją (pvz. atidarius drawer)
  function initAllDotsOnce() {
    const navs = document.querySelectorAll(
      '.mini-cart .cart-recommendations .mini-cart__navigation'
    );
    navs.forEach(updateDotsForNav);
  }

  // Persikrauname mini-cart ir cart icon burbulus GET'u su ?sections=
  function refreshCartSections() {
    return fetch(
      window.location.pathname +
        '?sections=' +
        encodeURIComponent(SECTIONS_TO_RENDER.join(',')),
      {
        headers: { Accept: 'application/json' },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        // mini-cart
        if (sections['mini-cart']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(
            sections['mini-cart'],
            'text/html'
          );
          const section = doc.querySelector('.shopify-section');
          if (section) {
            const container = document.getElementById('mini-cart');
            if (container) {
              container.innerHTML = section.innerHTML;
            }
          }
        }

        // desktop burbulas
        if (sections['cart-icon-bubble']) {
          const parser2 = new DOMParser();
          const doc2 = parser2.parseFromString(
            sections['cart-icon-bubble'],
            'text/html'
          );
          const section2 = doc2.querySelector('.shopify-section');
          if (section2) {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = section2.innerHTML;
          }
        }

        // mobile burbulas
        if (sections['mobile-cart-icon-bubble']) {
          const parser3 = new DOMParser();
          const doc3 = parser3.parseFromString(
            sections['mobile-cart-icon-bubble'],
            'text/html'
          );
          const section3 = doc3.querySelector('.shopify-section');
          if (section3) {
            const mbubble = document.getElementById('mobile-cart-icon-bubble');
            if (mbubble) mbubble.innerHTML = section3.innerHTML;
          }
        }

        // po perpiešimo – atnaujinam aktyvų burbuliuką
        initAllDotsOnce();

        // pranešam, kad mini-cart atnaujintas
        document.dispatchEvent(
          new CustomEvent('mini-cart:updated', { bubbles: true })
        );
      })
      .catch(function (error) {
        console.error('Error refreshing cart sections', error);
      });
  }

  // Pakeičiam variantą: 1) nuimam seną eilutę 2) pridedam naują variantą (+ gaunam sekcijas iš /cart/add.js)
  function changeLineVariant(line, newVariantId, quantity) {
    // 1) nuimam seną eilutę
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: 0,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        // 2) pridedam naują variantą ir paprašom sekcijų (bundled section rendering)
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: parseInt(newVariantId, 10), // saugiai paverčiam į skaičių
            quantity: quantity,
            sections: SECTIONS_TO_RENDER.join(','), // 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble'
            sections_url: window.location.pathname,
          }),
        });
      })
      .then(function (response) {
        return response.json(); // čia jau yra { sections: { 'mini-cart': '<html>', ... }, ... }
      });
  }

  // Inicijuojam burbuliukų būseną, kai puslapis užsikrauna
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDotsOnce);
  } else {
    initAllDotsOnce();
  }

  // Kai mini-cart atnaujinamas arba drawer atsidaro – vėl atnaujinam
  document.addEventListener('mini-cart:updated', initAllDotsOnce);
  document.addEventListener('cartdrawer:opened', initAllDotsOnce);

  // Scroll listeneris – kai slenkame horizontaliai per rekomendacijas
  document.addEventListener(
    'scroll',
    function (event) {
      const target = event.target;
      if (
        !target ||
        !target.classList ||
        !target.classList.contains('mini-cart__navigation')
      ) {
        return;
      }
      updateDotsForNav(target);
    },
    true // capture – kad gautume scroll eventą iš pačio elemento
  );

  document.addEventListener('click', function (event) {
    // 0) Burbuliukai – peršokimas į konkretų produktą
    const dot = event.target.closest('.mini-cart__dot');
    if (dot) {
      event.preventDefault();
      const nav = getNavFromDot(dot);
      if (!nav) return;

      const dots = getDotsForNav(nav);
      const items = getItemsForNav(nav);
      if (!dots.length || !items.length) return;

      const dotsArray = Array.prototype.slice.call(dots);
      const index = dotsArray.indexOf(dot);
      const targetItem = items[index];
      if (!targetItem) return;

      const targetLeft = targetItem.offsetLeft;

      if (typeof nav.scrollTo === 'function') {
        nav.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
      } else {
        nav.scrollLeft = targetLeft;
      }

      // iškart atnaujinam aktyvų burbuliuką (be scroll laukimo)
      updateDotsForNav(nav);
      return;
    }

    // 1) Atidaryti / uždaryti dropdown (variant picker)
    const trigger = event.target.closest('.cart-variant-picker__trigger');
    if (trigger) {
      const picker = trigger.closest('.cart-variant-picker');
      if (!picker) return;

      event.preventDefault();
      event.stopPropagation();

      const isOpen = picker.classList.contains('cart-variant-picker--open');
      closeAllVariantPickers();
      if (!isOpen) {
        picker.classList.add('cart-variant-picker--open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // 2) Pasirinktas konkretus variantas
    const option = event.target.closest('.cart-variant-picker__option');
    if (option) {
      event.preventDefault();
      event.stopPropagation();

      const picker = option.closest('.cart-variant-picker');
      const newVariantId = option.dataset.variantId;
      if (!picker || !newVariantId) return;

      // drawer'e tai <li>, cart puslapyje – <tr class="cart-item">
      const cartItem = picker.closest('li, tr.cart-item');
      if (!cartItem) return;

      const qtyInput = cartItem.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const line = qtyInput
        ? parseInt(
            qtyInput.dataset.index || qtyInput.getAttribute('data-index'),
            10
          )
        : null;

      if (!line) return;

      // OPTIMISTINIS UI – keičiam tekstą iškart
      const triggerBtn = picker.querySelector('.cart-variant-picker__trigger');
      const labelNode =
        triggerBtn && triggerBtn.firstChild && triggerBtn.firstChild;
      const labelText = option.textContent.trim();

      if (labelNode && labelNode.nodeType === Node.TEXT_NODE) {
        labelNode.textContent = labelText + ' ';
      } else if (triggerBtn && triggerBtn.childNodes[0]) {
        triggerBtn.childNodes[0].textContent = labelText + ' ';
      }

      // Uždaryti dropdown
      picker.classList.remove('cart-variant-picker--open');

      // Loading overlay ant konkretaus item – su nedideliu delay, kad labai greiti request'ai nerodytų ratuko
      const overlay = cartItem.querySelector('.loading-overlay');
      let overlayTimeout = null;
      if (overlay) {
        overlayTimeout = setTimeout(function () {
          overlay.classList.remove('hidden');
        }, 150);
      }

      // ar esame cart drawer'yje?
      const inDrawer = !!picker.closest('cart-drawer');

      changeLineVariant(line, newVariantId, quantity)
        .then(function (cartState) {
          if (inDrawer) {
            // Drawer’is – naudojam <mini-cart> komponentą ir jo renderContents
            const miniCartEl = document.querySelector('mini-cart');

            if (miniCartEl && typeof miniCartEl.renderContents === 'function') {
              miniCartEl.renderContents(cartState);
            } else {
              // fallback, jei dėl kažkokių priežasčių nėra mini-cart elemento
              return refreshCartSections();
            }
          } else if (document.getElementById('main-cart-items')) {
            // Cart puslapis – pilnas reload (paliekam kaip buvo)
            window.location.reload();
          }
        })
        .catch(function (error) {
          console.error('Error changing cart variant', error);
          // saugus fallback, jei kas nors nepavyko
          window.location.reload();
        })
        .finally(function () {
          if (overlayTimeout) clearTimeout(overlayTimeout);
          if (overlay) overlay.classList.add('hidden');
        });

      closeAllVariantPickers();
      return;
    }

    // 3) Bet kur kitur – uždarom dropdownus
    if (!event.target.closest('.cart-variant-picker')) {
      closeAllVariantPickers();
    }
  });
})();